import React from 'react';
import styles from './WorkWithUs.module.css';
import workWithUsImage from '/assets/images/lavora-con-noi.jpg';
import { useTranslation } from "react-i18next";
import appConfig from '../../config/appConfig';
import SubHeaderDefault from '../Header/subHeader/SubHeaderDefault';

const WorkWithUs: React.FC = () => {
    const { t } = useTranslation();

    const offers = [
        t('workWithUsPage.section2.offer1'),
        t('workWithUsPage.section2.offer2'),
        t('workWithUsPage.section2.offer3'),
        t('workWithUsPage.section2.offer4'),
    ];
    
    return (
        <>
            <SubHeaderDefault title={t('workWithUsPage.pageTitle')} isSeo={true} />

            <section className={styles.workWithUsSection}>
            
            {/* Immagine */}
            <div className={styles.imageContainer}>
                <a href={'mailto:' + appConfig.agency.agencyEmail} >
                    <img
                        src={workWithUsImage}
                        alt={`${t('workWithUsPage.image1.imageAlt')} - Select Immobiliare`}
                        className={styles.imageStyles}
                        width={appConfig.ui.workWithUsPage.image.width}
                        height={appConfig.ui.workWithUsPage.image.height}
                    />
                </a>
            </div>

            <div className={styles.textContent}>

                {/* Paragrafi introduttivi */}
                <p className={styles.introText}>{t('workWithUsPage.generalParagraph1')}</p>
                <p className={styles.introText}>{t('workWithUsPage.generalParagraph2')}</p>

                <hr className={styles.sectionDivider} />

                {/* Sezioni di contenuto (Chi cerchiamo, Cosa offriamo) */}
                <div className={styles.contentGridInternal}>

                    {/* Sezione "Chi cerchiamo" */}
                    <div className={styles.gridItem}>
                        <h3 className={styles.sectionTitle}>{t('workWithUsPage.section1.title')}</h3>
                        <p>{t('workWithUsPage.section1.text')}</p>
                    </div>

                    {/* Sezione "Cosa offriamo" */}
                    <div className={styles.gridItem}>
                        <h3 className={styles.sectionTitle}>{t('workWithUsPage.section2.title')}</h3>
                        <ul className={styles.offerList}>
                            {offers.map((offer, index) => (
                                <li key={index} className={styles.offerItem}>
                                    <span>{offer}</span>
                                </li>
                            ))}
                        </ul>
                    </div>

                </div>

                <hr className={styles.sectionDivider} />

                {/* Sezione CTA (Vuoi candidarti?) */}
                <div className={styles.ctaSection}>
                    <h3 className={styles.ctaTitle}>{t('workWithUsPage.section3.title')}</h3>
                    <p className={styles.ctaText}>
                        {t('workWithUsPage.section3.writeTo')}
                        <a
                            href={'mailto:' + appConfig.agency.agencyEmail}
                            className={styles.emailLink}
                        >
                            {appConfig.agency.agencyEmail}
                        </a>
                    </p>
                </div>

                <blockquote className={styles.inspirationalQuote}>
                    {t('workWithUsPage.section3.quote')}
                </blockquote>
            </div>
        </section>
        </>
    );
};

export default WorkWithUs;